// src/api.js  — centralised axios client
import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  timeout: 30000,
});

// Attach JWT token on every request
API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('fh_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Redirect to login on 401
API.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('fh_token');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

// ── Auth ─────────────────────────────────────────────────────
export const login  = (email, password) => API.post('/api/auth/login', { email, password });
export const getMe  = ()                 => API.get('/api/auth/me');

// ── Employees ────────────────────────────────────────────────
export const getEmployees      = ()       => API.get('/api/employees');
export const createEmployee    = (data)   => API.post('/api/employees', data);
export const updateEmployee    = (id, data) => API.patch(`/api/employees/${id}`, data);
export const deleteEmployee    = (id)     => API.delete(`/api/employees/${id}`);
export const getEmployeeProgress = (id)   => API.get(`/api/employees/${id}/progress`);

// ── Folders ──────────────────────────────────────────────────
export const getFolders   = ()     => API.get('/api/folders');
export const createFolder = (data) => API.post('/api/folders', data);
export const deleteFolder = (id)   => API.delete(`/api/folders/${id}`);

// ── Videos ───────────────────────────────────────────────────
export const getVideos       = (folderId) => API.get('/api/videos', { params: folderId ? { folder_id: folderId } : {} });
export const uploadVideo     = (formData) => API.post('/api/videos', formData, { headers:{'Content-Type':'multipart/form-data'}, timeout: 300000 });
export const getPresignedUrl = (filename, contentType) => API.post('/api/videos/presign', { filename, contentType });
export const createVideoRecord = (data)   => API.post('/api/videos', data);
export const getVideoUrl     = (id)       => API.get(`/api/videos/${id}/watch`);
export const deleteVideo     = (id)       => API.delete(`/api/videos/${id}`);
export const updateProgress  = (id, data) => API.patch(`/api/videos/${id}/progress`, data);

// ── Assignments ──────────────────────────────────────────────
export const getAssignments    = ()       => API.get('/api/assignments');
export const createAssignment  = (data)   => API.post('/api/assignments', data);
export const deleteAssignment  = (id)     => API.delete(`/api/assignments/${id}`);
export const submitAssignment  = (id, data) => API.post(`/api/assignments/${id}/submit`, data);

// ── Quizzes ──────────────────────────────────────────────────
export const getQuizzes        = ()       => API.get('/api/quizzes');
export const getMyQuizAttempts = ()       => API.get('/api/quizzes/my-attempts');
export const getQuizQuestions  = (id)     => API.get(`/api/quizzes/${id}/questions`);
export const createQuiz        = (data)   => API.post('/api/quizzes', data);
export const deleteQuiz        = (id)     => API.delete(`/api/quizzes/${id}`);
export const submitQuizAttempt = (id, answers) => API.post(`/api/quizzes/${id}/attempt`, { answers });

// ── Dashboard ────────────────────────────────────────────────
export const getDashboard       = ()  => API.get('/api/dashboard');
export const getMyDashboard     = ()  => API.get('/api/dashboard/me');
export const getMyVideoProgress = ()  => API.get('/api/videos/my-progress');

export default API;
